// extracted by mini-css-extract-plugin
export default {"container":"RoutesCellRenderer_container__Zf7eJ","tag":"RoutesCellRenderer_tag__xEF3t"};